import { Booth, State, BoothType } from './types';

const getters = {
  getPrimaryBooths(state: State): Array<Booth> {
    const primaryBooths = Object.values(state.booths).filter(booth => booth.booth_type === BoothType.primary);
    return primaryBooths.sort((a, b) => a.rank - b.rank);
  },
  getSecondaryBooths(state: State): Array<Booth> {
    const secondaryBooths = Object.values(state.booths).filter(booth => booth.booth_type === BoothType.secondary);
    return secondaryBooths.sort((a, b) => a.rank - b.rank);
  },
  getBoothById: (state: State) => (boothId: string) => state.booths[boothId]
};

export default getters;
